// src/AppWrapped.js
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppProvider } from './AppContext';
import App from './App';

export default function AppWrapped() {
  return (
    <BrowserRouter>
      <AppProvider>
        <App />
      </AppProvider>
    </BrowserRouter>
  );
}
 